import { Col, Form, Row, TreeSelect } from 'antd';
import { FormField } from 'components';
import get from 'lodash/get';
import omit from 'lodash/omit';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateFormField } from 'store/forms/actions';
import {
  formFieldsActivityArea
} from './formFields';
import moment from 'moment';
import { useForm } from 'antd/lib/form/Form';
import { isBeneficiary} from 'utils';
import { isNil, isEmpty } from 'lodash';
import { treeData } from 'utils/treeData';
import { Tag } from 'antd';


const ActivityArea = () => {
  const dispatch = useDispatch();
  const user = useSelector(state => state.user);
  const applicationReturned = useSelector(state => state.forms?.carrier?.applicationReturned);
  const municipalitiesActivityArea = useSelector(state => state.forms.carrier.municipalitiesActivityArea);
  const regionalUnitiesActivityArea = useSelector(state => state.forms.carrier.regionalUnitiesActivityArea);
  const selectedActivityAreasCodes = useSelector(state => state.forms.carrier.selectedActivityAreasCodes);
  const activeTaskName = useSelector(state => state?.forms?.activeTaskName);
  const [form] = useForm();
  const carrier = useSelector(state => state.forms.carrier);
  const [hasInteracted, setHasInteracted] = useState(false);
  const isViewMode = useSelector(state => state.forms.carrier.viewMode);
  const viewMode = isViewMode || 
                    !isBeneficiary(user.groups) || 
                    applicationReturned ||
                    activeTaskName === "task.name.temporary_rejected" ||
                    activeTaskName === "task.name.application_returned_to_supplier" ||
                    activeTaskName === "task.name.accepted";

  const handleChange = ({ key, type, event }) => {
    let newValue;
    if (type === 'text' || type === 'textarea' || type === 'radio') {
      newValue = event.target.value;
    } else if (type === 'date') {
      newValue = new Date(event).toLocaleDateString();
    } else if (type === 'select' || type === 'number') {
      newValue = event;
    }
    if (newValue === ' ' && key==='marketing') {
      newValue = ''
    }
    dispatch(
      updateFormField({
        group: 'carrier',
        key,
        value: newValue,
      })
    );
  };

  
  //Epikratia -- Select All
  const getAllLocationCodes = (treeNodes) => {
    let codes = [];
    
    const traverse = (nodes) => {
      if (!nodes) return;
      
      nodes.forEach(node => {
        if (node.value) {
          codes.push(node.value);
        }
        
        if (node.children) {
          traverse(node.children);
        }
      });
    };
    
    traverse(treeNodes);
    return codes;
  };
  
  const onChange = (newValue) => {
    setHasInteracted(true);
    
    // Get all possible location codes except nationwide
    const allLocationCodes = getAllLocationCodes(treeData).filter(code => code !== 'nationwide');

    // If user selects "Επικράτεια"
    if (newValue.includes('nationwide') && !selectedActivityAreasCodes.includes('nationwide')) {
      // Include all location codes
      const updatedSelection = ['nationwide', ...allLocationCodes];
      
      // Process for regionalUnities and municipalities
      let tempRegionalUnities = new Set();
      let tempMunicipalities = new Set();
      
      allLocationCodes.forEach((value) => {
        if (value.includes('$')) {
          let parts = value.split('$');
          tempRegionalUnities.add(parts[0]);
          tempMunicipalities.add(parts[1]);
        } else {
          tempRegionalUnities.add(value);
        }
      });
      
      // Update Redux
      dispatch(
        updateFormField({
          group: 'carrier',
          key: 'selectedActivityAreasCodes',
          value: updatedSelection,
        })
      );
      
      dispatch(
        updateFormField({
          group: 'carrier',
          key: 'regionalUnitiesActivityArea',
          value: [...tempRegionalUnities],
        })
      );
      
      dispatch(
        updateFormField({
          group: 'carrier',
          key: 'municipalitiesActivityArea',
          value: [...tempMunicipalities],
        })
      );
    }
    // If user deselects "Επικράτεια"
    else if (!newValue.includes('nationwide') && selectedActivityAreasCodes.includes('nationwide')) {
      // Clear all selections
      dispatch(
        updateFormField({
          group: 'carrier',
          key: 'selectedActivityAreasCodes',
          value: [],
        })
      );
      
      dispatch(
        updateFormField({
          group: 'carrier',
          key: 'regionalUnitiesActivityArea',
          value: [],
        })
      );
      
      dispatch(
        updateFormField({
          group: 'carrier',
          key: 'municipalitiesActivityArea',
          value: [],
        })
      );
    }
    // For regular selections (not involving nationwide)
    else {
      // Check if all location codes are now selected
      const shouldIncludeNationwide = allLocationCodes.every(code => newValue.includes(code));
      
      // If all locations are selected, add nationwide
      if (shouldIncludeNationwide && !newValue.includes('nationwide')) {
        newValue.push('nationwide');
      }
      // If not all locations are selected, remove nationwide
      else if (!shouldIncludeNationwide && newValue.includes('nationwide')) {
        newValue = newValue.filter(value => value !== 'nationwide');
      }
      
      // Process for regionalUnities and municipalities
      let tempRegionalUnities = new Set();
      let tempMunicipalities = new Set();
      
      newValue.forEach((value) => {
        if (value.includes('$')) {
          let parts = value.split('$');
          tempRegionalUnities.add(parts[0]);
          tempMunicipalities.add(parts[1]);
        } else if (value !== 'nationwide') {
          tempRegionalUnities.add(value);
        }
      });
      
      // Update Redux
      dispatch(
        updateFormField({
          group: 'carrier',
          key: 'selectedActivityAreasCodes',
          value: newValue,
        })
      );
      
      dispatch(
        updateFormField({
          group: 'carrier',
          key: 'regionalUnitiesActivityArea',
          value: [...tempRegionalUnities],
        })
      );
      
      dispatch(
        updateFormField({
          group: 'carrier',
          key: 'municipalitiesActivityArea',
          value: [...tempMunicipalities],
        })
      );
    }
  };

  useEffect(() => {
    form.setFieldsValue({
      companyName: carrier.companyName,
      abiVat: carrier.abiVat,
      street:
        carrier.abiStreet && carrier.abiStreetNumber
          ? carrier.abiStreet + ' ' + carrier.abiStreetNumber
          : '',
      abiTk: carrier.abiTk,
      abiPerfecture: carrier.abiPerfecture,
      abiDistrict: carrier.abiDistrict,
      invMob: carrier.invMob,
      mainKAD: carrier?.taxis_data?.mainKadDescription, // carrier.mainKAD
      website: carrier.website,
      invMail: carrier.invMail,
      companyLegalType: carrier.companyLegalType,
      companySize: carrier.companySize,
      regionalUnitiesActivityArea:carrier?.regionalUnitiesActivityArea,
      municipalitiesActivityArea:carrier?.municipalitiesActivityArea,
      marketing:carrier.marketing,
    });
  }, [form, carrier]);



  const renderFieldValue = field => {
    const value = get(carrier, field.name, '');
    return field.type === 'date' ? (value ? moment(value) : '') : value;
  };

  return (
    <>
    <Form
      form={form}
      initialValues={{
        ...carrier,
      }}
      trigger="onChange"
    >
    <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} className='mt-2'>
      <Col span={24}>
        <Row>
        <div className='activity-location-selector mt-2'>      
          <p className="mt-0 mr-0 font-size-16 text-bold ">
            Επιλέξτε τις Περιφερειακές Ενότητες ή/και Δήμους εντός των οποίων επιθυμείτε να δραστηριοποιηθείτε
            <span className="color-red"> *</span>
          </p> 
          <TreeSelect
            treeCheckable= {true}
            style={{
              width:'40%',
              minWidth:'400px',
            }}
            value={selectedActivityAreasCodes}
            dropdownStyle={{
              maxHeight: 400,
              overflow: 'auto',
            }}
            showCheckedStrategy={TreeSelect.SHOW_ALL}
            placeholder="Επιλέξτε Περιοχές Δραστηριότητας"
            allowClear
            disabled={viewMode}
            onChange={onChange}
            treeData={[
              {
                title: 'Επικράτεια',
                value: 'nationwide',
                key: 'nationwide',
              },
              ...treeData
            ]}
            multiple={true}
            maxTagPlaceholder={<span><b className='regions'>{regionalUnitiesActivityArea?.length}</b>  Περιφερειακές Ενότητες  <b className='municipalities'>{municipalitiesActivityArea?.length}</b> Δήμοι</span>}
            maxTagCount={0}
            className="checkboxes-container align-items-center"
          />
          {(!viewMode && hasInteracted) && (
            <>
              { 
                (isNil(municipalitiesActivityArea) || isEmpty(municipalitiesActivityArea)) &&
                (isNil(regionalUnitiesActivityArea) || isEmpty(carrier?.regionalUnitiesActivityArea)) && 
                <div role="alert" className="ant-form-item-explain-error mt-1 mb-2">
                  Παρακαλώ συμπληρώστε Περιφερειακές Ενότητες ή/και Δήμους
                </div>
              }
            </>
          )} 
        </div>
        </Row>
        {!isNil(regionalUnitiesActivityArea) || !isNil(municipalitiesActivityArea?.length) ?
        <Row
          gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
          className="mt-3 carrier-data-form"
        >
          {regionalUnitiesActivityArea?.length!==0 ? 
            <Col span={24}>
            <div className='mt-3'>Περιφερειακή Ενότητα</div>
            <div className='mt-2' name="regionalUnitiesActivityArea">          
              {regionalUnitiesActivityArea?.map(value=>(<Tag >{value}</Tag>))}
            </div>
            </Col>
          : null}
          {municipalitiesActivityArea?.length!==0 ? 
            <Col span={24}>
            <div className='mt-6'>Δήμος<span className="color-red"> *</span></div>
            <div className='mt-2' name="municipalitiesActivityArea">           
              {municipalitiesActivityArea?.map(value=>(<Tag >{value}</Tag>))}
            </div>
          </Col>
          
          : null}
        </Row>:null}
      </Col>
    </Row>
    <Row
        gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
        className="mt-4 carrier-data-form"
    >
      <Col span={24}>
          <p className="mt-0 mr-0 font-size-16 text-bold">
            Σχετικά με τον Προμηθευτή 
            <span className="color-red"> *</span>
          </p>
          {formFieldsActivityArea.map((field, index) => {
          return (
            <Col key={index} style={{paddingLeft:'0', width:'100%'}} span={field.span}>
              <Form.Item
                name={[field.name]}
                rules={field.rules}
                value={renderFieldValue(field)}
                validateFirst
              >
                <FormField
                  key={index}
                  //value={[carrier[field.name]]}
                  disabled={viewMode || applicationReturned || activeTaskName === "task.name.temporary_rejected"}
                  {...omit(field, ['span'])}
                  onChange={value =>
                    handleChange({
                      key: field.name,
                      type: field.type,
                      event: value,
                    })
                  }
                />
              </Form.Item>
            </Col>
          )})}
        </Col>
      </Row>
    </Form>
  </>
  );
};

export default ActivityArea;
